import React from "react";
import { Button } from "semantic-ui-react";
import '../css/custom.css';
import logo from '../img/em_logo.svg'

const Error = (props: {}) => {

    // This page appears if CollectData.tsx does not load
    return (
        <div className="diversityText">
            <div className="content">
                <table className="table" aria-labelledby="tableLabel"><tbody>
                    <tr>
                        <td className="logo-cell"><img src={logo} className='logo' alt="" /></td>
                        <td className='header-text'>Diversity, Equity, and Inclusion Survey</td>
                    </tr>
                </tbody></table>
                <div className='question-instructions-title'>
                    <div style={{ fontSize: 24, marginTop: 20 }}><b>Error: We’re sorry. Something has gone wrong.</b></div>
                    <div style={{ marginTop: 10 }}>Please close this window and try again later.</div>
                </div>
            </div>
            <div className="footer">
                <hr className="line-1"></hr>
                <div className="buttonAlign">
                    <Button type="submit" className="blue-submit-button" onClick={() => window.close()}>Return to Publication</Button>
                </div>
            </div>
        </div>
    )
}

export default Error